module.exports = __webpack_public_path__ + "img/43.3.TP.afcb473d.png";